// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ModalHeader__modalHeader___EBfFi {
    cursor: move;
    -webkit-user-select: none;
       -moz-user-select: none;
            user-select: none;

    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;

    height: 4rem;
    padding: 1.2rem;

    border-bottom: 0.1rem solid var(--color-bg-border);
}

.ModalHeader__title___lGpLk {
    display: flex;
    flex-direction: row;
    gap: 0.9rem;
    align-items: center;
}

.ModalHeader__controls___jp0UX {
    display: flex;
    flex-direction: row;
    gap: 0.8rem;
}
`, "",{"version":3,"sources":["webpack://./../GM.Frontend.Library/src/components/Modals/ProcessModals/ModalHeader/ModalHeader.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,yBAAiB;OAAjB,sBAAiB;YAAjB,iBAAiB;;IAEjB,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,8BAA8B;;IAE9B,YAAY;IACZ,eAAe;;IAEf,kDAAkD;AACtD;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;AACf","sourcesContent":[".modalHeader {\n    cursor: move;\n    user-select: none;\n\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: space-between;\n\n    height: 4rem;\n    padding: 1.2rem;\n\n    border-bottom: 0.1rem solid var(--color-bg-border);\n}\n\n.title {\n    display: flex;\n    flex-direction: row;\n    gap: 0.9rem;\n    align-items: center;\n}\n\n.controls {\n    display: flex;\n    flex-direction: row;\n    gap: 0.8rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modalHeader": `ModalHeader__modalHeader___EBfFi`,
	"title": `ModalHeader__title___lGpLk`,
	"controls": `ModalHeader__controls___jp0UX`
};
export default ___CSS_LOADER_EXPORT___;
